import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header>
            <b>Welcome to JS NoteBook ❤️</b>
            
        </header>
    );
};

export default Header;
